"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectWeatherUnitOption')(function selectWeatherUnitOption(weatherUnit, state) {
    var optionState = state.optionState;
    optionState.weatherUnit = weatherUnit;
}));
//# sourceMappingURL=selectWeatherUnitOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-weather-option/lib/actions/selectWeatherUnitOption.js
// module id = 5257
// module chunks = 2